import React, { PropsWithChildren } from 'react';

import NextLink from 'next/link';
import { LinkProps as NextLinkProps } from 'next/dist/client/link';
import {
  Link as ChakraLink,
  LinkProps as ChakraLinkProps,
} from '@chakra-ui/react';

export type NextChakraLinkProps = PropsWithChildren<
  NextLinkProps & Omit<ChakraLinkProps, 'as'>
>;

const NextChakraLink: FCWithChildren<NextChakraLinkProps> = ({
  href,
  children,
  ...rest
}) => {
  return (
    <NextLink passHref href={href}>
      {/* eslint-disable-next-line @typescript-eslint/ban-ts-comment */}
      {/* @ts-ignore */}
      <ChakraLink {...rest}>{children}</ChakraLink>
    </NextLink>
  );
};

export default NextChakraLink;
